import React, { ReactNode, useCallback } from 'react';

import { Tab } from '../Tab/Tab';
import { useTabs } from './providers/TabsProvider';
import { Wrapper } from './styles/components';

export const Tabs = ({
  tabsTitle,
  displayTabs = true,
  children,
  ...props
}: {
  tabsTitle: string[];
  children: ReactNode;
  displayTabs?: boolean;
}) => {
  const { currentTab } = useTabs();

  const renderTabs = useCallback(
    function renderTabs(title, index) {
      return (
        <Tab
          key={title}
          index={index}
          isCurrentTab={index === currentTab}
          title={title}
        />
      );
    },
    [currentTab]
  );

  return (
    <>
      {displayTabs && (
        <Wrapper role="toolbar" {...props}>
          {tabsTitle.map(renderTabs)}
        </Wrapper>
      )}
      {children}
    </>
  );
};
